import React, { useContext } from 'react';
import { IconButton } from 'office-ui-fabric-react';

import { context } from './context';

import { Styled } from './BCResult.styles';
import { getEmptyVehiclesTableString } from '../../ControllerTask/BCResult/utils';

export const Vehicles: React.FC = () => {
  const {
    setEditingVehicleIndex,
    resultTask,
    setResultTask,
    tickets,
  } = useContext(context);

  const onAddRow = () => {
    setResultTask((prev) => {
      if (!prev) return null;
      return {
        ...prev,
        check_vehicles: [
          ...prev.check_vehicles,
          getEmptyVehiclesTableString(tickets),
        ],
      };
    });
    if (resultTask) {
      setEditingVehicleIndex(resultTask?.check_vehicles.length);
    }
  };

  return (
    <Styled.MainBlock>
      <h2>Проверки ТС</h2>
      {resultTask?.check_vehicles.map(({ route_short_name, depot_number }, index) => (
        <Styled.VehicleWrapper onClick={() => setEditingVehicleIndex(index)}>
          <div>{route_short_name}</div> <div>{depot_number}</div>
        </Styled.VehicleWrapper>
      ))}
      <IconButton
        iconProps={{
          iconName: 'Add',
        }}
        onClick={onAddRow}
      />
    </Styled.MainBlock>
  );
};
